/** API rows are authoritative; an explicit catalog restricts rows to that catalog. */
export function completeDiameterRows<T extends { diameter: number }>(rows: T[], blank: (diameter: number) => T, catalog?: number[]): T[] {
  const allowed = catalog ? new Set(catalog.map(Number)) : undefined;
  const byDiameter = new Map(rows.filter(row => !allowed || allowed.has(Number(row.diameter))).map(row => [Number(row.diameter), row]));
  (catalog || []).map(Number).forEach(diameter => {
    if (!byDiameter.has(diameter)) byDiameter.set(diameter, blank(diameter));
  });
  return [...byDiameter.values()].sort((a, b) => a.diameter - b.diameter);
}
